import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
function UserDeleteForm({ handleClose, dataToAlter, deleteUserHandler }) {
  return (
    <div>
      <Typography variant="body1">
        Delete the record for {dataToAlter.name}?
      </Typography>
      <Typography variant="body1">This cannot be undone!</Typography>
      <div className="users-modal-buttons">
        <Button className="siteBlueOutlined" onClick={handleClose}>
          cancel
        </Button>
        <Button className="siteRedOutlined" onClick={deleteUserHandler}>
          delete user
        </Button>
      </div>
    </div>
  );
}
UserDeleteForm.propTypes = {
  handleClose: PropTypes.func,
  dataToAlter: PropTypes.object,
  deleteUserHandler: PropTypes.func,
};
export default UserDeleteForm;
